import { AbstractControl } from '@angular/forms';
import { QuarterRangeSelectorValue } from './quarter-selector.model';

/**
 * Validates that the quarter selector value is fulfilled
 */

export function FullQuarterValidator(control: AbstractControl): { [key: string]: any } | null {
  const value: QuarterRangeSelectorValue = control.value;
  if (value !== null) {
    let hasSomeValues = false;
    let internalValuesAreCorrect = true;
    const allValues = Object.values(value);
    for (const val of allValues) {
      if (val) {
        hasSomeValues = true;
        const valueWrong = val.periodValue == null || val.periodValue <= 0;
        const yearWrong = val.periodYear == null || val.periodYear <= 0;
        if (valueWrong && yearWrong) {
          internalValuesAreCorrect = false;
          break;
        }
      }
    }
    if (hasSomeValues && internalValuesAreCorrect) {
      return null;
    }
  }

  return { required: { value } };
}
